import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

import SvgIcon from './SvgIcon.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'IconRenderer',
  props: {
        size: {type: Number, default: 18},
        active: Boolean,
        name: String,
        color: {
            type: String,
            default: 'var(--joy-color-neutral-60)',
        },
        // any, dirty sorry
        icon: {},
        canBeActive: {type: Boolean, default: true},
    },
  setup(__props) {

const props = __props;

    

return (_ctx: any,_cache: any) => {
  return (typeof props.icon === 'string')
    ? (_openBlock(), _createBlock(SvgIcon, _mergeProps({
        key: 0,
        src: props.icon
      }, props, { "can-be-active": __props.canBeActive }), null, 16, ["src", "can-be-active"]))
    : (_openBlock(), _createBlock(_resolveDynamicComponent(props.icon), _normalizeProps(_mergeProps({ key: 1 }, props)), null, 16))
}
}

})